module.exports = __webpack_public_path__ + "img/cytg.205c7e81.svg";